/**
 * @name Friendlycaptcha
 * @namespace COMMON.Friendlycaptcha
 */
COMMON.Friendlycaptcha = function ($, friendlyChallenge) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = "friendlycaptcha";
  var DATA_KEY = "common." + NAME;
  var EVENT_KEY = "." + DATA_KEY;
  var DATA_API_KEY = ".data-api";
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '[data-spy=friendlycaptcha]'
  };

  var SITEKEY = 'FCMN81DKTCFTUUGG';
  var PUZZLE_ENDPOINT_URL = 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle';

  var Default = {
    startMode: 'focus',
    language: 'de',
    solutionFieldName: 'frc-captcha-solution'
  };

  var DefaultType = {
    startMode: 'string',
    language: 'string',
    solutionFieldName: 'string'
  };

  /**
   *
   */
  var Friendlycaptcha = function () {

    function Friendlycaptcha(element, config) {
      COMMON.Utils._classCallCheck(this, Friendlycaptcha);

      var self = this;

      self.element = element;
      self.$element = $(self.element);

      self.config = self._getConfig(config);

      self._initialize();
    }

    Friendlycaptcha.prototype._initialize = function _initialize() {
      var self = this;

      /**
       * @see https://docs.friendlycaptcha.com/#/widget_api?id=javascript-api
       *
       * @type {object}
       * @property {string} [startMode='focus']
       * @property {string} sitekey
       * @property {function} [readyCallback]
       * @property {function} [startedCallback]
       * @property {function} [doneCallback]
       * @property {function} [errorCallback]
       * @property {string|object} [language]
       * @property {string} [solutionFieldName='frc-captcha-solution']
       * @property {string} [puzzleEndpoint]
       * @property {bool} [skipStyleInjection=false]
       */
      var options = {
        sitekey: SITEKEY,
        puzzleEndpoint: PUZZLE_ENDPOINT_URL,
        readyCallback: function () {
          self.element.classList.add('frc-captcha');
          if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            self.element.classList.add('dark');
          }
          console.debug('COMMON.Friendlycaptcha: solver is done initializing and is ready to start', self.element);
        },
        startedCallback: function () {
          self.wasStarted = true;
          console.debug('COMMON.Friendlycaptcha: solver has started', self.element);

          var formGroup = self.element.closest('.form-group');
          if (null === formGroup) {
            return;
          }
          var formError = formGroup.querySelector('.form-error');
          if (null === formError) {
            return;
          }
          formError.parentNode.removeChild(formError);
        },
        doneCallback: function (solution) {
          console.debug('COMMON.Friendlycaptcha: CAPTCHA has been completed', solution, self.element);
          $(document).trigger('common:friendly-captcha:completed');
        },
        errorCallback: function (error) {
          console.debug('COMMON.Friendlycaptcha: internal error occured', error, self.element);
          $(document).trigger('common:friendly-captcha:error');
        },
        skipStyleInjection: true
      }

      var _options = $.extend({}, options, self.config);

      console.debug('COMMON.Friendlycaptcha: options', self.element, _options);

      self.wasStarted = false;
      self.widget = new friendlyChallenge.WidgetInstance(self.element, _options)

      self.form = self.element.form;
      if (self.form) {
        $(self.form).on('change' + EVENT_KEY, function () {
          if (self.wasStarted || !self.form.checkValidity()) {
            return;
          }
          self.wasStarted = true;
          self.widget.start();
        })
      }

      $(document).on('pjax:end' + EVENT_KEY, function (event) {
        if (self.widget && 'function' === typeof self.widget.reset) {
          self.widget.reset();
        }
      })
    }

    // private
    Friendlycaptcha.prototype._getConfig = function _getConfig(config) {
      config = extend({}, Default, config);

      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    Friendlycaptcha.prototype.reset = function () {
      var self = this;

      if (self.widget && 'function' === typeof self.widget.reset) {
        self.widget.reset();
      }
    }

    // public
    Friendlycaptcha.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      if (this.form) {
        $(this.form).off(EVENT_KEY);
      }
      if (this.widget && 'function' === typeof this.widget.destroy) {
        this.widget.destroy();
        this.element.classList.remove('frc-captcha', 'dark')
      }

      this.form = null
      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    /**
     * @static
     */
    Friendlycaptcha._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : COMMON.Utils._typeof(config)) === 'object' ? config : null;

        if (!data) {
          data = new Friendlycaptcha(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named ' + config + '');
          }
          data[config]();
        }
      });
    };

    return Friendlycaptcha;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Friendlycaptcha._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Friendlycaptcha._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Friendlycaptcha._jQueryInterface;
  $.fn[NAME].Constructor = Friendlycaptcha;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Friendlycaptcha._jQueryInterface;
  };

  return Friendlycaptcha;

}(window.jQuery, window.friendlyChallenge);
